<template>
  <div id="PublicComponentInfo">
    <ul class="info-ul">
      <li class="info-li">
        <span class="label-col">{{ resourceCn }}ID</span>
        <span class="value-col">{{ publicResourceInfo.id }}</span>
      </li>
      <li class="info-li">
        <span class="label-col">创建人</span>
        <span class="value-col">{{ publicResourceInfo.creatorName }}</span>
      </li>
      <li class="info-li">
        <span class="label-col">创建时间</span>
        <span class="value-col">{{ $fmtTime(publicResourceInfo.createTime) }}</span>
      </li>
      <li class="info-li">
        <span class="label-col">更新时间</span>
        <span class="value-col">{{ $fmtTime(publicResourceInfo.updateTime) }}</span>
      </li>
      <li class="info-li">
        <span class="label-col">目录</span>
        <span class="value-col">
          <classify-select
            ref="spaceCategory"
            :options-tree="spaceClassifyTree"
            :init-value="spaceCategoryIds"
            :prop-obj="classifySelectProps"
            @selected="modifyClassify"
          />
        </span>
      </li>
    </ul>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Utils from '@/core/utils'
import ClassifySelect from '@/components/business/resource/classifySelect.vue'
import { getResourceType } from '@/assets/js/resourceMap.js'

export default {
  name: 'PublicComponentInfo',
  components: { ClassifySelect },
  props: {
    resourceType: {
      type: String,
      default: 'COMPONENT'
    }
  },
  data() {
    return {
      brandCode: '',
    }
  },
  computed: {
    ...mapGetters({
      spacePlatClassify: 'classifySpace/spacePlatClassify',
      spaceClassifyTree: 'classifySpace/spaceClassifyTree',
      currentResource: 'resourceDetail/currentResource',
      publicResourceInfo: 'resourceDetail/publicResourceInfo',
    }),
    classifySelectProps() {
      return {
        label: 'name',
        value: 'id',
        children: 'children',
        // 是否可以选择任意一级
        checkStrictly: true
      }
    },
    spaceCategoryIds() {
      const id = this.publicResourceInfo.spaceCategoryId
      const spaceCategoryObj = Utils.getPathByChild(this.spacePlatClassify, id, null)
      return spaceCategoryObj.ids || []
    },
    resourceCn() {
      return getResourceType(this.resourceType)
    },
    tagIds() {
      const tags = this.publicResourceInfo.tags || []
      return tags.map((tag) => tag.id)
    },
  },
  watch: {
    'publicResourceInfo.brandCode': {
      handler(newVal) {
        this.brandCode = newVal
      },
      immediate: true
    },
  },
  methods: {
    ...mapActions({
      loadPublicResourceInfo: 'resourceDetail/loadPublicResourceInfo'
    }),
    modifyClassify(value) {
      this.$api.resource.spaceCategory(this.currentResource.spaceId, {
        spaceResourceId: this.currentResource.spaceResourceId,
        spaceCategoryId: value
      }).then((res) => {
        if (res === true) {
          this.$message.success('修改成功')
        }
      }).catch((err) => {
        const errors = {
          'space.resource.not.exist': '资源不存在',
          'space.resource.name.duplicate': '所选分类中存在同名资源',
        }
        this.$matchError(err.code, errors, '修改失败')
        this.$refs.spaceCategory.reset()
      })
    },
  },
}
</script>

<style lang="less" scoped>
.info-ul{
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: baseline;
}
.info-li{
  width: 33.33%;
  padding-right: 10px;
  margin-bottom: 16px;
  display: flex;
  flex-direction: row;
  align-items: center;
  text-align: left;
  .label-col{
    flex: 0 0 68px;
    font-weight: 600;
  }
  .value-col{
    flex: 1;
  }
}
@media screen and (min-width: 1400px) {
  .info-li{
    width: 25%;
  }
}
</style>
